import type { Plugin } from './types.ts';

export interface CorsairPluginOptions {
  width?: number;
  color?: string;
  dash?: [number, number];
  display: boolean;
}

export const Corsair: Plugin<'line', Required<CorsairPluginOptions>> = {
  id: 'corsair',
  defaults: {
    width: 1,
    color: '#FF4949',
    dash: [3, 3],
    display: true,
  },
  afterInit: (chart) => {
    // @ts-expect-error no way to type custom plugins that i found
    chart.corsair = {
      x: 0,
      y: 0,
    };
  },
  afterEvent: (chart, { event }) => {
    const { tooltip } = chart;
    if (tooltip && event?.native) {
      const items = chart.getElementsAtEventForMode(event.native, 'point', {}, true);
      const { x, y } = items?.[0]?.element || {};
      // @ts-expect-error no way to type custom plugins that i found
      chart.corsair = { x, y, draw: !!items?.[0]?.element };
    }
  },
  beforeDatasetsDraw: (chart, args, opts) => {
    if (!opts.display) return;
    const { ctx } = chart;
    const { left, right } = chart.chartArea;
    // @ts-expect-error no way to type custom plugins that i found
    const { y, draw } = chart?.corsair || {};
    if (!draw) {
      return;
    }
    ctx.save();
    ctx.beginPath();
    ctx.lineWidth = opts.width;
    ctx.strokeStyle = opts.color;
    ctx.setLineDash(opts.dash);
    ctx.moveTo(left, y);
    ctx.lineTo(right, y);
    ctx.stroke();
    ctx.restore();
    chart.update();
  },
};
